import React from "react";
import { connect } from "react-redux";

import { List, ListItem, ListSubheader, makeStyles } from "@material-ui/core";
import { formatSplitwiseName } from "../../util";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

const SplitwisePage = ({ groups, friends }) => {
  const classes = useStyles();

  return (
    <div>
      <List
        subheader={<ListSubheader>Friends</ListSubheader>}
        className={classes.root}
        dense
      >
        {friends.map((friend, i) => (
          <ListItem key={i}>{formatSplitwiseName(friend)}</ListItem>
        ))}
      </List>
      <List
        subheader={<ListSubheader>Groups</ListSubheader>}
        className={classes.root}
        dense
      >
        {groups.map((group, i) => (
          <ListItem key={i}>{group.name}</ListItem>
        ))}
      </List>
    </div>
  );
};

const mapStateToProps = (state) => ({
  groups: state.splitwise.groups.filter((group) => group.id !== 0),
  friends: state.splitwise.friends,
});

export default connect(mapStateToProps, {})(SplitwisePage);
